export default __webpack_public_path__ + "static/media/019.196ee5c8.jpg";